import { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";
import { withLoaderAndSideEffects, withOnQueryStarted } from "./withOnQueryStareted";
import { retryFetch } from "./retryFetch";

const createMutation = (builder: EndpointBuilder<BaseQueryFn, never, 'baseApi'>, responseHandler: (response: any, api: any, arg: any) => void) => {
    return builder.mutation<any, { baseURL: string, payload: any, method?: string, arguments?: any }>({
        queryFn: withLoaderAndSideEffects(async (
            arg: { baseURL: string, payload: any, method?: string, arguments?: any },
            _api: BaseQueryFn,
            _extra: unknown,
            fetch: (args: any) => Promise<any>
        ) => {
            const { baseURL, payload, method = 'POST' } = arg;
            const response = await retryFetch(
                async () =>
                    fetch({
                        url: baseURL,
                        method,
                        body: payload,
                    })
            );

            if (response && (response as any).error) {
                return { error: (response as any).error };
            }
            if (responseHandler) responseHandler(response, _api, arg);
            const payloadData: any = response && (response as any).data !== undefined ? (response as any).data : response;
            return { data: payloadData };
        }),
        onQueryStarted: withOnQueryStarted()
    });
};

export default createMutation;
